import React from "react"
import PropTypes from "prop-types"
import Moment from "moment"

// Components
import LineChart from "../components/LineChart/LineChart"
import HorizontalStackedBar from "../components/HorizontalStackedBar/HorizontalStackedBar"
import resizeComponent from "../components/ResizeComponent/ResizeComponent"

// Resizable Components
const ResizableLineChart = resizeComponent(LineChart)
const ResizableHorizontalStackedBar = resizeComponent(HorizontalStackedBar)

const AnalyzeRisksContent = props => {
  // Props
  const { behaviorType, scoresDistributions, monthlyScore } = props

  let monthlyDistribution
  if (
    behaviorType &&
    scoresDistributions &&
    scoresDistributions[behaviorType] &&
    scoresDistributions[behaviorType].distribution
  ) {
    monthlyDistribution = scoresDistributions[behaviorType].distribution
  }

  const newLabels = []
  const lineDataLabels = []

  if (monthlyScore) {
    monthlyScore.forEach((_item, index) => {
      const monthItem = Object.keys(monthlyScore[index])
      newLabels.push(Moment(monthItem, "YYYY-MM").format("MMM"))
      // validate that the data is structured as expected
      const monthlyScoreGroup = monthlyScore[index][monthItem[0]]
      if (
        monthlyScoreGroup.groups[behaviorType] &&
        monthlyScoreGroup.groups[behaviorType].scores &&
        monthlyScoreGroup.groups[behaviorType].scores.score
      ) {
        lineDataLabels.push({
          month: Moment(monthItem, "YYYY-MM").toDate(),
          score: monthlyScoreGroup.groups[behaviorType].scores.score
        })
      } else {
        console.error(
          `DNA-906 Data error: .groups.${behaviorType}.scores.score not found in ${monthlyScoreGroup}`
        )
      }
    })
  }

  return (
    <div>
      <div className="card-block p-4 d-flex flex-column flex-lg-row">
        <div className="flex flex-column justify-content-between flex-50 min-width-0 h-100">
          <div className="ar-influence-container">
            <h3 className="font-weight-bold">Distribution</h3>
            <div>
              <ResizableHorizontalStackedBar data={monthlyDistribution} />
            </div>
          </div>
        </div>
      </div>
      <div className="card-block p-4 d-flex flex-column flex-lg-row">
        <div className="ar-influence-container">
          <h3 className="card font-weight-bold">Historical Trend</h3>
          <div className="score-title">SCORE</div>
          <div className="d-flex flex-column justify-content-end h-100 w-100">
            <ResizableLineChart
              lineData={monthlyScore}
              title={behaviorType}
              labels={newLabels}
              lineDataLabels={lineDataLabels}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default AnalyzeRisksContent

AnalyzeRisksContent.propTypes = {
  behaviorType: PropTypes.string,
  scoresDistributions: PropTypes.shape(),
  monthlyScore: PropTypes.arrayOf(PropTypes.shape())
}

AnalyzeRisksContent.defaultProps = {
  behaviorType: "overall",
  scoresDistributions: {},
  monthlyScore: null
}
